import { BaseDto } from "@models/base/baseDto.model";

export class UpdateRolRequest  extends BaseDto{
}
